module.exports = __webpack_public_path__ + "media/site/images/logos/cooperstandard-logo-385c6ac8ea9d72e9c29122655867ca9d.svg";